<style lang="scss" src='./style/index.scss'></style>
<template>
    <stepLayout
        :model="model"
        :before-close="before_close"
        :close="hide"
        :title="title"
        :visible.sync="dialogVisble">
        <div class="stepDialogBox" slot="step-main">
            <template v-if="!innerPage">
                <nav class="step step-little">
                    <div class="step-wrapper">
                        <div
                            v-for="(item, index) in options"
                            :key="index"
                            class="steps"
                            style="width: 100%;"
                            :class="{active: stepIndex === (index+1)}">
                            <span>{{index+1}}.{{item.title}}</span>
                        </div>
                    </div>
                </nav>
                <div class="stepContent">
                    <template v-for="(item, index) in options">
                        <div
                            class="car"
                            :key="index"
                            :class="{active: stepIndex === index + 1}">
                            <slot :name="'step-' + (index + 1)"></slot>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else>
                <slot name="inner-page"></slot>
            </template>
        </div>
        <span slot="step-footer" class="dialog-footer" v-if="showBtn">
               <div class="dialog-footer__tools" :class="{'is-right': model === 'inner'}">
                   <slot name="footer-tool"></slot>
               </div>
               <div class="addImpowerDialogFooter" v-show="!innerPage">
                   <el-button
                       v-show="status && !options[stepIndex - 1]['prev-btn-hide']"
                       :class="{active:stepIndex == 1}"
                       @click="close">取&nbsp;消</el-button>
                    <el-button
                        v-show="status && !options[stepIndex - 1]['prev-btn-hide']"
                        :class="{active:stepIndex !== 1}"
                        @click="stepIndex = stepIndex - 1">上一步</el-button>
                    <el-button
                        v-if="options[stepIndex-1]['btn']"
                        :loading="loading"
                        :class="{active:stepIndex !== options.length}"
                        type="primary"
                        @click="nextStep">{{options[stepIndex-1]['btn']}}</el-button>
                    <el-button
                        :loading="loading"
                        :class="{active:stepIndex === options.length}"
                        type="primary"
                        @click="stepfinish">
                        <span
                            v-html="lastBtnText"></span>
                    </el-button>
               </div>
               <div v-show="innerPage">
                   <slot name="inner-page-footer"></slot>
               </div>
        </span>
    </stepLayout>
</template>
<script>
/*
 * =====================================
 * name    : 分布式表单验证对话框
 * version : v1.0.1
 * time    : 2017-11-15 16:50:36
 * auth    : huyingjun
 * e-mail  : yingjun.hu@geely.com
 * =====================================
 * update  :
 *
 * 1、增加promise异步请求进行下一步操作
 *
 * time    : 2017-12-01 14:47:46
 * auth    : huyingjun
 * e-mail  : yingjun.hu@geely.com
 *
 * 2、增加innerset 模式，不弹出对话框直接在相应位置显示
 *
 * props:
 * model: 模式字段，可供选择innerset和Dialog,默认Dialog
 *
 * 3、增加step.sync
 *
 * 4、增加插槽step-footer__tool，底部按钮边上的插槽文字，经常用作工具类的控件使用
 * =====================================
 */
import Vue from 'vue';
import { Dialog } from 'element-ui';
import stepLayout from './layout';

Vue.use(Dialog);
Vue.use(stepLayout);

export default {
  name: 'stepDialog',
  props: {
    title: String,
    visible: Boolean,
    options: Array,
    beforeClose: Function,
    finish: Function,
    next: Function,
    data: Object,
    step: Number,
    model: {
      type: String,
      default: 'Dialog',
    },
  },
  data() {
    return {
      innerPage: false,
      showBtn: true,
      loading: false,
      status: true,
      stepIndex: this.step,
      dialogVisble: this.visible, // 传递开关初始值
    };
  },
  watch: {
    visible(val) {
      if (val) this.show();
      else this.hide();
    },
    stepIndex(val) {
      this.$emit('update:step', val);
      if (val) {
        // 状态初始化
        this.startOrEndDeal(false);
      }

      this.showBtn = false;
      this.$nextTick(() => {
        this.showBtn = true;
      });
    },
  },
  computed: {
    dialogTitle() {
      return this.options[this.stepIndex - 1].title
        ? this.options[this.stepIndex - 1].title
        : this.title;
    },
    mediaWidth() {
      const { width } = this.options;
      console.log(typeof width);
      if (typeof width === 'number') {
        return `${width}px`;
      } if (typeof width === 'string') {
        return width;
      }
      return width;
    },
    mediaHeight() {
      return `${this.options.height}px`;
    },
    lastBtnText() {
      return this.options[this.stepIndex - 1].btn
        ? this.options[this.stepIndex - 1].btn
        : '完&nbsp;成';
    },
  },
  methods: {
    show() {
      // 每次显示初始化第一步
      this.stepIndex = this.step ? this.step : 1;
      // 运用sync修饰符语法糖，触发v-on update事件
      this.$emit('update:visible', true);
      this.dialogVisble = true;
    },
    hide() {
      // 运用sync修饰符语法糖，触发v-on update事件
      this.$emit('update:visible', false);
      if (this.beforeClose()) this.dialogVisble = false;
    },
    before_close(done) {
      if (this.beforeClose()) done();
    },
    close() {
      if (this.beforeClose()) this.hide();
    },
    nextStep() {
      this.next(this.data, () => {
        this.stepIndex++;
      }, this.stepIndex, (promise) => {
        this.dealPromise(promise, this.stepIndex);
      }, () => {
        this.startOrEndDeal(false);
      });
    },
    stepfinish() {
      this.finish(this.data, (promise) => {
        this.dealPromise(promise);
      }, () => {
        this.startOrEndDeal(false);
      });
    },
    startOrEndDeal(bool) {
      if (bool) {
        this.status = false;
        this.loading = true;
      } else {
        this.status = true;
        this.loading = false;
      }
    },
    // 处理异步加载ajax
    dealPromise(promise, stepIndex) {
      console.log('处理异步加载ajax');
      // 判断该对象为promise
      if (promise
        && typeof promise === 'object'
        && typeof promise.then === 'function') {
        // 开始处理异步
        this.startOrEndDeal(true);
        promise.then((res) => {
          // 当所有异步处理完成后改变状态
          console.log(`处理完成${stepIndex}`);
          if (stepIndex === this.stepIndex
            && (!res || res.code === 'success')) this.stepIndex++;
          if (typeof stepIndex !== 'undefined') this.startOrEndDeal(false);
          else {
            // 异步处理完之后就要恢复状态。 最后一步交给业务处理
            // this.startOrEndDeal(false);
          }
        });
      }
    },
    // 打开内嵌页面
    openInnerPage() {
      this.innerPage = true;
    },
    // 关闭内嵌页面
    closeInnerPage() {
      this.innerPage = false;
    },
  },
  mounted() {

  },
};

</script>
